export default "__VITE_ASSET__DOxlpuv5__"